<template>
  <div class="stock-container">
    <div class="fixed-wrapper">
      <div class="stock-header">
        查询委托库存
      </div>
      <div class="search-row">
        <div class="stock-order">
          <span>委托单号</span>
          <el-input
            v-model="entrustCode"
            placeholder="请输入委托单号"
            clearable
            size="mini"
          ></el-input>
        </div>
        <div class="stock-material">
          <span>物料名称/编码</span>
          <el-input
            v-model="material"
            placeholder="请输入物料名称或物料编码"
            clearable
            size="mini"
          ></el-input>
        </div>
        <div class="stock-batch">
          <span>批次号</span>
          <el-input
            v-model="batchCode"
            placeholder="请输入批次号"
            clearable
            size="mini"
          ></el-input>
        </div>
        <el-button type="primary" size="mini" :loading="isLoading" @click="handleSearch"
          >查询</el-button
        >
      </div>
    </div>
    <div class="stock-content">
      <el-table
        :data="stockList"
        size="mini"
        style="width: 100%"
        height="100%"
        v-loading="isLoading"
      >
        <el-table-column prop="entrustCode" label="委托单号" width="120">
        </el-table-column>
        <el-table-column prop="itemCode" label="物料编码" width="120">
        </el-table-column>
        <el-table-column prop="itemName" label="物料名称" width="180">
        </el-table-column>
        <el-table-column prop="batchCode" label="批次号" width="150">
        </el-table-column>
        <el-table-column label="品项" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.itemQualityName | qualityType" size="mini">
              {{ scope.row.itemQualityName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="检测报价" width="80">
        </el-table-column>
        <el-table-column prop="scale" label="分成比例" width="80">
        </el-table-column>
        <el-table-column prop="stockQuantity" label="入库数" width="80">
        </el-table-column>
        <el-table-column prop="returnQuantity" label="寄回数" width="80">
        </el-table-column>
        <el-table-column prop="soldQuantity" label="已售数" width="80">
        </el-table-column>
        <el-table-column prop="rentingQuantity" label="已出租" width="80">
        </el-table-column>
        <el-table-column prop="quotaQuantity" label="当前库存" width="80">
        </el-table-column>
        <el-table-column prop="stockpileDay" label="存放天数" width="80">
        </el-table-column>
        <el-table-column prop="stockTime" label="入库时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.stockTime | date }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <span class="view" @click="viewDetail(scope.row.id)">查看</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      entrustCode: '',
      material: '',
      batchCode: '',
      stockList: [],
      isLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  beforeCreate() {
    this.$store.commit('setActiveIndex', '/indent')
    this.$store.commit('setSubActiveIndex', '/indent/stock')
    this.$store.commit('setAsideWidth', 300)
  },
  created() {
    this.getStockList()
  },
  methods: {
    getStockList() {
      this.isLoading = true
      const params = {
        entrustCode: this.entrustCode,
        keyword: this.material,
        batchCode: this.batchCode,
        skipCount: (this.currentPage - 1) * this.pageSize,
        maxResultCount: this.pageSize
      }
      this.$http
        .get('/api/services/inquiryApp/entrust/GetAllEntrustStock', params)
        .then(res => {
          this.stockList = res.result.items
          this.total = res.result.totalCount
          this.isLoading = false
        })
        .catch(err => {
          console.log(err)
          this.$message.error('获取数据失败！')
          this.isLoading = false
        })
    },
    handleSearch() {
      this.currentPage = 1
      this.getStockList()
    },
    viewDetail(id) {
      this.$router.push({
        path: '/indent/stock-detail',
        query: {
          id: id
        }
      })
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.currentPage = 1
      this.getStockList()
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage
      this.getStockList()
    }
  }
}
</script>
<style lang="less" scoped>
.stock-container {
  height: 100%;
  width: 100%;
  min-width: 1200px;
  background-color: #ffffff;
  font-family: 'Source Han Sans CN';
  padding: 20px;
  overflow: auto;
}
.stock-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.fixed-wrapper {
  width: 100%;
  margin-bottom: 20px;
}
.stock-order,
.stock-supplier,
.stock-material,
.stock-batch {
  width: 18%;
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-right: 30px;
  span {
    margin-right: 15px;
    color: #2f343c;
  }
}
.stock-material {
  width: 25%;
}
.search-row {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.view {
  cursor: pointer;
  color: #027cff;
}
.stock-content {
  height: calc(100% - 170px);
}
.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
